import axios from 'axios'
import Vue from 'vue'
import dialog from './AccountSelectDepartment.vue'

const Dialog = Vue.extend(dialog);

let resolves = [];
let rejects = [];

class AccountSelectDepartment {
  static $data = {
    items: [],
    loading: false,
  };

  constructor() {

  }

  static open(id) {
    return new Promise((resolve, reject) => {
      AccountSelectDepartment
        .dialog(id)
        .then(data => {
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    })
  }

  static dialog(id) {
    return new Promise((resolve, reject) => {
      let dialog = new Dialog({
        data: {
          visible: false,
          id: id,
          loading: true,
          options: [],
        },
      });
      AccountSelectDepartment
        .get_list()
        .then(data => {
          dialog.loading = false;
          dialog.options = AccountSelectDepartment.items;
        })
        .catch(reject);
      dialog.destroyed = () => {
        setTimeout(() => {
          document.body.removeChild(dialog.$el);
        }, 300);
      };
      dialog.click = (value) => {
        if (value) {
          dialog.loading = true;
          AccountSelectDepartment
            .select(dialog.id)
            .then(value => {
              dialog.close();
              resolve(value);
            })
            .catch(err => {
              dialog.close();
              reject();
            });
        } else {
          dialog.close();
          reject();
        }
      };
      dialog.close = () => {
        dialog.visible = false;
        setTimeout(() => {
          dialog.$destroy();
        }, 300);
      };
      document.body.appendChild(dialog.$mount().$el);
      setTimeout(() => {
        dialog.visible = true;
      });

    });
  }

  static get_list() {
    return new Promise((resolve, reject) => {
      if (AccountSelectDepartment.$data.items.length) return resolve(AccountSelectDepartment);
      AccountSelectDepartment.$data.loading = true;
      axios
        .post('tourclient/MasterAgent/Dictionary/Department', 'request=%7B%7D')
        .then(({data}) => {
          AccountSelectDepartment.$data.items = data.Items.map(i => ({value: i.Id, label: i.Name}));
          AccountSelectDepartment.$data.loading = false;
          resolve(AccountSelectDepartment);
        })
        .catch(err => {
          AccountSelectDepartment.$data.loading = false;
          reject(err);
        })
    });
  }

  static select(value) {
    return new Promise((resolve, reject) => {
      axios
        .post('/tourclient/account/CurrentUserDepartment', `id=${value}`)
        .then(({data}) => {
          if (data && data.Success) resolve(value);
          else reject();
        })
        .catch(reject)
    });
  }

  static get items() {
    return AccountSelectDepartment.$data.items;
  }

  static get loading() {
    return AccountSelectDepartment.$data.loading;
  }
}


export default AccountSelectDepartment;